import http from './http';

const gpaForecastServices = {
  // async getGpaForeCastById(gpa_forecast_id: any) {
  //   const res = await http.get(`api/gpa-forecast/${gpa_forecast_id}`);
  //   return res;
  // },

  async getGpaForeCast(student_id: any) {
   const body = {
      student_id: student_id
   };
    const res = await http.post(`api/gpa-forecast/search/by_student_id`, body);  
    return res;
  },

  async getGpaForeCastByGradeNo(studentId:any, gradeNo: number) {
    const body = {
      student_id: Number(studentId ?? 0),
      grade_no: gradeNo
    };
     const res:any[] = await http.post(`api/gpa-forecast/search/by_grade_no`, body);  
     return res;
   },

  async syncGpaForecast(studentId: any) {
    const res = await http.get(`api/grade-and-college-course/sync_gpa_forecast/${studentId}`);
    return res;
  },

  async syncGpaForecastGradeNo(studentId: any, gradeNo:number) {
    const body = {
      student_id: Number(studentId ?? 0),
      grade_no: gradeNo
    };
    const res = await http.post('api/grade-and-college-course/sync_gpa_forecast', body);
    return res;
  },

};

export default gpaForecastServices;
